/* stylelint-disable */
import { css, SerializedStyles } from '@emotion/react';

export const freshChatStyle = (isCasino: boolean): SerializedStyles => css`
    #fc_frame.fc-launcher-text, #fc_frame.fc-widget-small.fc-launcher-text {
        bottom: ${isCasino ? '50px !important' : '90px !important'};
        right: 2px !important;
        @media(min-width: 1024px){
            bottom: 20px !important;
            right: 15px !important;
        }
    }
`;
